import { on } from "svelte/events";
import { defineComponent } from "../../../common/runtime/defineComponent.svelte";
import { props } from "./utils/props";
import type { Props } from "./SheetV1.types";
import { sheetCreate, sheetOpenById } from "./apis/methods";

defineComponent<Props & { container?: string; info?: unknown; sheetId?: string }>({
  tag: "oc-sheet-trigger-v1",
  extendOptions: { useShadow: false },
  props: {
    ...props,
    sheetId: { attribute: "sheet-id", reflect: true },
    container: { attribute: "container" },
    info: { type: "Object", attribute: "info" },
  },
  onMount: (host, p) => {
    return on(host, "click", () => {
      const { info, container, sheetId, ...config } = p;

      /*                                                                         */
      delete config.open;
      /*                                                                         */
      config.id = sheetId;

      /*                                                                                                               */
      const containerElement =
        (container && document.querySelector<HTMLElement>(container)) || host.parentElement;

      /*                                                                                                                     */
      const sheetElement = sheetCreate(config as never, { container: containerElement });

      /*                                                      */
      host.sheetId = sheetElement.id;

      /*                                  */
      sheetOpenById(sheetElement.id, { info });
    });
  },
});
